import axios from 'axios';
import { BACKEND_URL } from './api';

/* Two-way sync: Energy tile (Phase 3 worship notes · scheduled_time)
   ⇄ Aura Codex energy pillar alarms (localStorage). */

const CODEX_KEY = 'aura_codex_state_v1';
const tzOffsetMin = () => -new Date().getTimezoneOffset();

const notesToAlarms = (notes) => {
  const timed = (notes || [])
    .filter((n) => n.scheduled_time && n.is_active !== false)
    .sort((a, b) => a.scheduled_time.localeCompare(b.scheduled_time))
    .slice(0, 5);
  return { alarms: timed.map((n) => n.scheduled_time), alarmNoteIds: timed.map((n) => n.note_id) };
};

/* Energy tile → Codex. Safe to call with the full notes list any time. */
export const pushNotesToCodex = (notes) => {
  const detail = notesToAlarms(notes);
  try {
    const raw = localStorage.getItem(CODEX_KEY);
    const st = raw ? JSON.parse(raw) : { pillars: {} };
    st.pillars = st.pillars || {};
    st.pillars.energy = { ...(st.pillars.energy || { fused: false, tasks: [], window: { start: '', end: '' }, lastFusedAt: 0 }), ...detail };
    localStorage.setItem(CODEX_KEY, JSON.stringify(st));
  } catch (_) { /* storage blocked */ }
  window.dispatchEvent(new CustomEvent('codex-energy-sync', { detail }));
};

export const pullEnergyNotesIntoCodex = async () => {
  try {
    const { data } = await axios.get(`${BACKEND_URL}/api/divine/worship-notes`);
    pushNotesToCodex(Array.isArray(data) ? data : []);
  } catch (_) { /* offline — keep local alarms */ }
};

/* Codex → Energy tile. Returns the updated alarmNoteIds (or null). */
export const pushCodexEnergyToNotes = async (prev, next) => {
  const prevAlarms = prev?.alarms || [];
  const prevIds = prev?.alarmNoteIds || [];
  const alarms = next?.alarms || [];
  const ids = alarms.map((_, i) => (next?.alarmNoteIds || [])[i] || null);
  let changed = false;
  try {
    for (let i = 0; i < alarms.length; i += 1) {
      const t = alarms[i];
      if (!t) continue;
      const id = ids[i];
      if (id) {
        const before = prevAlarms[prevIds.indexOf(id)];
        if (before !== t) {
          await axios.put(`${BACKEND_URL}/api/divine/worship-notes/${id}`, { scheduled_time: t, tz_offset_min: tzOffsetMin() });
          changed = true;
        }
      } else {
        const { data } = await axios.post(`${BACKEND_URL}/api/divine/worship-notes`, {
          title: 'Prayer', content: 'Prayer time set from Aura Codex.', decree: '',
          scheduled_time: t, tz_offset_min: tzOffsetMin(),
        });
        ids[i] = data?.note_id || null;
        changed = true;
      }
    }
    const removed = prevIds.filter((id) => id && !ids.includes(id));
    for (const id of removed) {
      await axios.put(`${BACKEND_URL}/api/divine/worship-notes/${id}`, { scheduled_time: null });
      changed = true;
    }
  } catch (_) { /* offline — retry on next edit */ }
  if (changed) window.dispatchEvent(new CustomEvent('divine:profile-updated'));
  return ids;
};

/* Debounced wrapper so rapid picker edits make one round-trip. */
let pending = null;
export const scheduleCodexEnergyPush = (prev, next, onIds) => {
  if (pending) { clearTimeout(pending.timer); pending.next = next; pending.onIds = onIds; }
  else pending = { prev, next, onIds };
  pending.timer = setTimeout(async () => {
    const job = pending; pending = null;
    const ids = await pushCodexEnergyToNotes(job.prev, job.next);
    if (ids) job.onIds(ids);
  }, 700);
};
